import { useOutstandingHours } from "@/lib/query/shift/use-outstanding-hours";

/**
 * Welke tabbladen een bolletje krijgen.
 *
 * Eén regel houdt dit bruikbaar: een bolletje betekent dat er iets op _jou_ wacht en dat je het weg
 * kunt maken. Alles wat je niet kunt afvinken hoort er niet -- een tabblad dat altijd een stip
 * draagt is na een week geen signaal meer maar decoratie, en dan mis je ook de stip die er wel toe
 * doet.
 *
 * Daarom staat er niets op Ontdek (een markt is geen takenlijst), niets op Vandaag (dat scherm zegt
 * zelf al wat er te doen is) en niets op Profiel (een half ingevuld profiel blijft half ingevuld
 * tot jij dat wilt, en daar is de nudge al voor).
 *
 * Blijft over: **Diensten** -- een afgelopen dienst waarvan de uren nog ingediend moeten worden.
 * Precies de teller die het scherm zelf op zijn segment zet, dus de stip en het getal eronder
 * kunnen niet uit elkaar lopen.
 *
 * Er stonden er drie. **Berichten** telde ongelezen gesprekken, en op Diensten telde een
 * uitnodiging waar de planner op jouw antwoord wachtte even zwaar als openstaande uren. Beide
 * liepen via het communicatieblok -- gesprekken en campagnes -- en zijn daarmee verdwenen (stap 4
 * van `admin/docs/communicatie-verwijderen.md`).
 *
 * Geen getallen op de tabbalk: hoeveel het er zijn zie je zodra je er bent, en een getal in de balk
 * nodigt uit tot vergelijken in plaats van tot openen.
 */
export type TabAlerts = {
  shifts: boolean;
};

export function useTabAlerts(): TabAlerts {
  // Zelfde query als Vandaag en Diensten gebruiken, dus voor wie die schermen opent kost dit niets
  // extra's.
  const outstandingHours = useOutstandingHours();

  return {
    shifts: outstandingHours.count > 0,
  };
}
